var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-grey-lightest" }, [
    _c(
      "section",
      { staticClass: "pt-12 pb-24", attrs: { id: "heading" } },
      [_c("header-nav", { ref: "headerNav" })],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "py-12" }, [
      _c(
        "div",
        { staticClass: "max-w-sm mx-auto px-6" },
        [
          !_vm.office
            ? _c("patient-loading")
            : _c(
                "div",
                { staticClass: "rounded bg-white shadow relative -mt-24" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                      attrs: { to: { path: "/" } }
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-close" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-6" }, [
                    _c(
                      "div",
                      { staticClass: "mb-4 flex" },
                      [
                        _c("avatar", {
                          staticClass: "mr-4 w-10 h-10",
                          attrs: {
                            avatar: _vm.office.doctorAvatar,
                            name:
                              _vm.office.doctorFirstName +
                              " " +
                              _vm.office.doctorLastName
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-black text-lg font-semibold mb-1"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.office.doctorFirstName) +
                                    " " +
                                    _vm._s(_vm.office.doctorLastName)
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.office.isDoctorRegulated &&
                            (_vm.office.doctorType !== "OSTEOPATH" &&
                              _vm.office.doctorType !== "PSYCHOLOGIST")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-green font-semibold text-sm mb-1"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-currency-eur"
                                    }),
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("Contracted_doctor"))
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.office.isDoctorRegulated &&
                            (_vm.office.doctorType !== "OSTEOPATH" &&
                              _vm.office.doctorType !== "PSYCHOLOGIST")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-red font-semibold text-sm mb-1"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-currency-eur"
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("Contracted_doctor_negative")
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.office.isDoctorMemberOfOsteopathie
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "tooltip text-green font-semibold text-sm mt-1 mb-2"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-check-circle"
                                    }),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t("Member_of_Osteopathie")
                                        ) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "tooltip-text text-sm" },
                                      [_vm._v(_vm._s(_vm.$t("Oste_tooltip")))]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.office.officeSettings
                              ? _c("OfficeSettings", {
                                  attrs: {
                                    accessible:
                                      _vm.office.officeSettings.accessible,
                                    card: _vm.office.officeSettings.card,
                                    cash: _vm.office.officeSettings.cash
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {}, [
                      _c("div", { staticClass: "text-grey-darkest" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.office.name)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.office.streetNumber) +
                            " " +
                            _vm._s(_vm.office.streetName)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.office.zipCode) +
                            " " +
                            _vm._s(_vm.office.locality) +
                            "\n                        "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "gmap-map",
                    {
                      staticClass: "w-full",
                      staticStyle: { height: "250px" },
                      attrs: {
                        center: {
                          lat: _vm.office.location._lat,
                          lng: _vm.office.location._long
                        },
                        zoom: 13,
                        options: { disableDefaultUI: true }
                      }
                    },
                    [
                      _c("gmap-marker", {
                        attrs: {
                          position: {
                            lat: _vm.office.location._lat,
                            lng: _vm.office.location._long
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.loadingTimeslots
                    ? _c("div", [
                        Object.keys(_vm.timeslots).length
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "uppercase tracking-wide text-grey-darker text-sm font-semibold px-3 md:px-6 my-4"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Select_an_availability"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "max-h-timeslots overflow-scroll"
                                },
                                [
                                  _vm._l(_vm.sortedTimeslots, function(
                                    timeslot
                                  ) {
                                    return _c(
                                      "router-link",
                                      {
                                        key: timeslot.id,
                                        staticClass:
                                          "block w-full border-t px-6 py-3 hover:bg-grey-lightest text-grey-darker",
                                        attrs: {
                                          to: {
                                            name: "timeslot.show",
                                            params: { id: timeslot.id }
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm._f("momentFormat")(
                                                timeslot.date,
                                                "YYYY-MM-DD",
                                                _vm.$t("date_selector_format")
                                              )
                                            ) +
                                            " " +
                                            _vm._s(_vm.$t("at")) +
                                            " " +
                                            _vm._s(
                                              _vm._f("momentFormatTime")(
                                                timeslot.time,
                                                _vm.$t("time_format")
                                              )
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "py-1 rounded-b border-t"
                                  })
                                ],
                                2
                              )
                            ])
                          : _c(
                              "div",
                              { staticClass: "px-6 py-4" },
                              [
                                _c("bubble", [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "X_is_not_available_Register_on_the_waiting_list_to_inform_the_dentists_near_Y",
                                          {
                                            name:
                                              _vm.office.doctorFirstName +
                                              " " +
                                              _vm.office.doctorLastName,
                                            location: _vm.patientPlace
                                          }
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  !_vm.hasEmergencies && !_vm.loadingTimeslots
                                    ? _c("p", { staticClass: "mt-2" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Activate_the_alert_and_I_will_inform_you_"
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasEmergencies && !_vm.loadingTimeslots
                                    ? _c("p", { staticClass: "mt-2" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "You_are_already_in_the_waiting_list"
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                !_vm.hasEmergencies && !_vm.loadingTimeslots
                                  ? _c("waiting-list-button")
                                  : _vm._e()
                              ],
                              1
                            )
                      ])
                    : _vm._e()
                ],
                1
              ),
          _vm._v(" "),
          _vm.office
            ? _c("dfp-slot", {
                staticClass: "mt-6",
                attrs: {
                  path: "/21865209613/Patients/OfficeShow",
                  size: [300, 250],
                  id: "div-gpt-ad-office",
                  "medical-practice": _vm.office.medicalPractice
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-274ad41a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-274ad41a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/OfficeShow.vue
// module id = 767
// module chunks = 1